import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { map } from 'rxjs';
import { selectAuthenticatedUser } from '../..';

export const masterGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.pipe(
    select(selectAuthenticatedUser),
    map(
      (user) =>
        !!user?.belongsToMasterGroup || router.createUrlTree(['/forbidden']),
    ),
  );
};
